/**
 * Functions for modifying the DOM.
 *
 * @module dom
 * @author EN GARDE
 * @version 1.3
 */

import $ from 'jquery';
import _ from 'lodash';
import * as jsHelper from './js.js';

/**
 * Sets custom capability classes (like `touch` or `no-touch`) to the html element.
 * @return {jQuery} HTML element
 */
export function setCapabilityClasses() {
	var $root = $(document.documentElement);

	// check for touch – regular touch devices & windows phone (see https://coderwall.com/p/egbgdw)
	if ('ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints) {
		$root.removeClass('no-touch');
		$root.addClass('touch');
	}

	// check for iOS
	if ('-webkit-overflow-scrolling' in document.body.style) {
		$root.addClass('ios');
	}
	else {
		$root.addClass('no-ios');
	}

	$root.removeClass('no-js');
	$root.addClass('js');

	return $root;
}

/**
 * Read values from a form and returns them as a (nested) object
 * @return {object} form data
 */
export function getFormData($form) {
	return jsHelper.deserializeQueryString($form.serialize());
}

/**
 * Update form elements using a data object. Opposite of getFormData()
 * @param {jQuery} $scope=$(document) only change fields in this scope
 * @param {object} data form data
 * @param {boolean} reset data that is not set in form data object
 */
export function setFormData($scope, data, force) {
	$scope = $scope || $(document);
	data = data || {};
	force = force === false ? false : true;

	var $fields = $scope.find(':input[name]');

	$fields.each(function(i, elem) {
		var $elem = $(elem);
		var type = $elem.attr('type');
		var name = $elem.attr('name');
		var nameClean = name;
		var isArrayLikeValue = name.lastIndexOf('[]') === name.length - 2;
		if (isArrayLikeValue) nameClean = name.substr(0, name.lastIndexOf('[]'));

		var value = $elem.val();
		var fieldData = _.get(data, nameClean);

		switch(type) {
			case 'radio':
			case 'checkbox':
				if (isArrayLikeValue && _.isArray(fieldData) && fieldData.indexOf(value) !== -1) {
					$elem.prop('checked', true);
				}
				else if (!isArrayLikeValue && fieldData === value) {
					$elem.prop('checked', true);
				}
				else {
					if (force) $elem.prop('checked', false);
				}
				break;
			default:
				if (fieldData) $elem.val(fieldData);
				else if (force) $elem.val('');
		}
	});
}
